module.exports = __webpack_public_path__ + "assets/img/scenePic21.4b2acdac.png";